import { QuestionnaireAnswer } from '@api';
import { DataCollectionInputs, ExistingFile } from '@types';

export function mapExistingQuestionnaire(questionnaireAnswer: QuestionnaireAnswer): DataCollectionInputs | null {
  // Tabular: modelType, dataPipeline, performanceMetricRanked (ids), protectedGroupsRanked (ids)
  const performanceMetricRanked =
    questionnaireAnswer.performanceMetrics?.map(metric => metric.id).filter(Boolean) ?? [];

  const protectedGroupsRanked =
    questionnaireAnswer.protectedGroupDataset?.protectedGroups?.map(group => group.id).filter(Boolean) ?? [];

  // FileUpload expects a `{ name }` shaped file (name doubling as the download path for
  // already-uploaded files), not the raw path string.
  const protectedGroupsFile: ExistingFile | undefined = questionnaireAnswer.protectedGroupDataset?.datasetPath
    ? { name: questionnaireAnswer.protectedGroupDataset.datasetPath }
    : undefined;

  // Text Generation: store ids so create/update payload works (reportType, insightfulnessCriteria, personalDataExposureCategories)
  const reportTypeId = questionnaireAnswer.reportType?.id != null ? questionnaireAnswer.reportType.id : undefined;

  const textGenerationInsightfulnessCriteria =
    questionnaireAnswer.insightfulnessCriteria?.map(criterion => criterion.id).filter(Boolean) ?? [];

  const textGenerationPersonalDataCategories =
    questionnaireAnswer.personalDataExposureCategories?.map(category => category.id).filter(Boolean) ?? [];

  const styleCriteria = questionnaireAnswer.styleCriteria?.map(criterion => criterion.id).filter(Boolean) ?? [];

  return {
    id: questionnaireAnswer.id,
    modelId: questionnaireAnswer.aiModel?.id,
    modelName: questionnaireAnswer.aiModel?.name,
    taskType: questionnaireAnswer.aiModel?.taskType,
    useCaseId: (questionnaireAnswer.aiModel as any)?.useCase ?? (questionnaireAnswer.aiModel as any)?.useCaseId,
    modelType: questionnaireAnswer.modelType ?? undefined,
    performanceMetricRanked,
    protectedGroupsRanked,
    protectedGroupsFile,
    existingProtectedGroupDatasetId: questionnaireAnswer?.protectedGroupDataset?.id ?? null,
    reportType: reportTypeId,
    textGenerationInsightfulnessCriteria,
    textGenerationPersonalDataCategories,
    styleCriteria,
  };
}
